var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgM3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Silhouettes",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 245,
    height: 245,
    viewBox: "0 0 245 245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .m3-cls1 {\n        fill: none;\n      }\n\n      .m3-cls2 {\n        fill: #3ab395;\n      }\n\n      .m3-cls3 {\n        clip-path: url(#m3-clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "m3-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m3-cls1",
    x: 198.94,
    y: 10.75,
    width: 27.41,
    height: 32.94,
    transform: "translate(47.71 164.17) rotate(-47)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "M3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_145",
    "data-name": "Groupe 145",
    transform: "translate(-5 12)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "m3-cls3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_141",
    "data-name": "Groupe 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_233",
    "data-name": "Trac\\xE9 233",
    className: "m3-cls2",
    d: "M204.27,38.12c-6.18-5.07-7.25-15.76-3.84-21.54,3.5-5.93,11.32-7.94,20.18-.6,6.16,5.11,10.36,12.98,6.36,19.74-3.42,5.79-15.32,8.46-22.71,2.4"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "m3-cls2",
    d: "M91.79,20.12C35.14,39.93,21.41,71.73,14.04,88.49s-9.38,44.01,3.65,72.32,34.78,53.23,59.95,67.16,34.31,18.28,59.2,18.7,54.28-10.55,73.83-36.7c19.55-26.16,23.06-64.83,18.42-96.61s-23.77-44.72-39.8-53.01c-16.03-8.3-73.05-48.77-97.5-40.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.71,229.37c-13.55-7.13-27.15-14.72-28.49-17.04-1.39-2.4-1.05-6.1-2.47-8.57-1.84-3.2-6.06-4.86-7.13-8.32-4.56-14.73,6.15-17.07,12.42-26.44,17.4-25.97,11.04-32.88,16.44-60.84,3.25-16.82,19.75-54.32,8.33-68.58-3.16-3.94-10.74-4.01-12.8-6.56-1.65-2.04-2.38-10.16-4.53-14.24-15.76-30.02-71.13-15.51-95.41-3.99-11.54,5.47-23.75,21-25.94,33.68-2.54,14.75,3.93,29.84,1.71,41.49-1.14,5.99-8.05,3.33-8.95,17.5-1.02,15.98,1.86,29.67,17.84,35.78,2.38,15.78-4.24,28.95-15.45,39.48-2.45,2.3-6.3,4.83-11.09,7.46,11.85,15.69,26.4,28.92,42.33,37.73,25.17,13.92,34.31,18.28,59.2,18.7,17.42.3,37.05-5,53.96-17.17,0-.03.01-.05.02-.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM3);
export default __webpack_public_path__ + "static/media/m3.7101649bdeb704ced22689819f624a26.svg";
export { ForwardRef as ReactComponent };